<template>
  <div class="shop">
    <div class="main">
      <img :src="url" alt="" />
      <!-- <img src="../../assets/shop/1.png" alt="" />
      <img src="../../assets/shop/2.png" alt="" />
      <img src="../../assets/shop/3.png" alt="" />
      <img src="../../assets/shop/4.png" alt="" />
      <img src="../../assets/shop/5.png" alt="" />
      <img src="../../assets/shop/6.png" alt="" />
      <img src="../../assets/shop/7.png" alt="" />
      <img src="../../assets/shop/8.png" alt="" />
      <img src="../../assets/shop/9.png" alt="" />
      <img src="../../assets/shop/10.png" alt="" />
      <img src="../../assets/shop/11.png" alt="" />
      <img src="../../assets/shop/12.png" alt="" />
      <img src="../../assets/shop/13.png" alt="" />
      <img src="../../assets/shop/14.png" alt="" /> -->
    </div>
    <div class="footer">
      <template v-if="isSubmited">
        <div class="submit">
          <img class="img" src="../../assets/submited.png" alt="" />
          <span>已提交，我们将尽快与您取得联系</span>
        </div>
      </template>
      <template v-else>
        <div class="footer-row">
          <div class="row row_1">
            <div class="col">
              <span class="col-title col-title_1">城市</span>
              <van-field
                placeholder="请选择"
                readonly
                clickable
                @click="showPicker = true"
                v-model="form.city"
                right-icon="arrow"
              />
            </div>
            <div class="col">
              <span class="col-title col-title_2">姓名</span>
              <van-field
                placeholder="请填写姓名"
                maxlength="10"
                v-model="form.customerName"
              />
            </div>
          </div>
          <div class="row row_2">
            <span class="row-title">手机号</span>
            <van-field
              type="digit"
              maxlength="11"
              placeholder="请填写手机号"
              v-model="form.mobile"
            >
              <template #button v-if="isSmsVisable">
                <div class="code-action code-action__disabled" v-if="isSmsSend">
                  {{ sendBtnText }}
                </div>
                <button class="code-action" v-else @click="handleSendSmsCode">
                  {{ sendBtnText }}
                </button>
              </template>
            </van-field>
          </div>
          <div class="row row_2 row_3" v-if="isSmsFieldVisable">
            <span class="row-title">验证码</span>
            <van-field
              type="digit"
              placeholder="请填写手机验证码"
              maxlength="4"
              v-model="form.smsCode"
            ></van-field>
          </div>
          <div class="footer-submit">
            <div
              class="submit-action submit-action__disabled"
              v-if="isOverlayShow"
            >
              <img src="../../assets/shop/shop.svg" alt="" />
            </div>
            <button class="submit-action" v-else @click="handleSubmitClick">
              <img src="../../assets/shop/shop.svg" alt="" />
            </button>
          </div>
        </div>
      </template>
      <van-popup
        v-model="showPicker"
        round
        position="bottom"
        :lock-scroll="false"
      >
        <van-picker
          ref="areaPicker"
          value-key="name"
          show-toolbar
          title="选择地区"
          item-height="34"
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { isPhone, isName, isCode } from "../../utils/validate";
import { getDownloadBanner } from "../../api";
import {
  getAreas,
  getSmsCode,
  addLeads,
  addLeadsSms,
  queryExistLeads,
} from "../../api";
export default {
  name: "Shop",
  data: () => {
    return {
      showPicker: false,
      columns: [],
      areaList: [],
      form: {
        city: null,
        provinceCode: null,
        cityCode: null,
        areaCode: null,
        customerName: null,
        mobile: null,
        smsCode: null,
      },
      phone: null,
      isSmsVisable: false,
      isSmsFieldVisable: false,
      isSmsSend: false,
      sendBtnText: "获取验证码",
      timer: null,
      counter: 60,
      isSmsAPI: false,
      isOverlayShow: false,
      isSubmited: false,
      isPlaying: false,
      currentIndex: 0,
      timer: null,
      url: "",
    };
  },
  mounted() {
    this.phone = this.$route.query.phone;
    this.form.mobile = this.phone;
    this.isSmsVisable = !this.phone;
    this.isSmsFieldVisable = false;
    this.getDownloadBannerRequest();
    this.getAreasRequest();
    this.queryExistLeadsRequest(this.phone);
  },
  methods: {
    getDownloadBannerRequest() {
      getDownloadBanner({ code: "Ad-sjgf-wyky-fullPage" }).then((res) => {
        this.url = res.data && res.data.length && res.data[0].url;

      });
    },
    getAreasRequest() {
      getAreas().then((res) => {
        const { code, data, message } = res;
        if (code === 200) {
          let areaList = [];
          data.map((item) => {
            const province = {
              name: item.name,
              mdCode: item.mdCode,
            };
            if (item.children && item.children.length) {
              item.children.map((cItem) => {
                const city = {
                  name: cItem.name,
                  mdCode: cItem.mdCode,
                };
                province.children = province.children || [];
                province.children.push(city);
              });
            }
            areaList.push(province);
          });
          this.columns = areaList;
          this.areaList = data;
        } else {
          this.$toast({ message });
        }
      });
    },
    queryExistLeadsRequest(mobile) {
      if (isPhone(mobile)) {
        queryExistLeads({ mobile }).then((res) => {
          if (res.code === 200) {
            if (res.busCode === "1") {
              this.isSubmited = res.data;
              this.isOverlayShow = false;
            } else {
              this.$toast({ message: res.busMessage });
              this.isOverlayShow = false;
            }
          } else {
            this.$toast({ message: res.message });
            this.isOverlayShow = false;
          }
        });
      }
    },
    handleVideoPlay() {
      console.log("play");
      this.isPlaying = true;
    },
    handleVideoPause() {
      console.log("pause");
      this.isPlaying = false;
    },
    handleVideoEnd() {
      console.log("end");
      this.isPlaying = false;
    },
    handleSwipeChange(index) {
      const swipe = this.swipes[this.currentIndex];
      console.log(this.currentIndex, index, swipe);
      if (swipe.type === "video") {
        const videoEle = document.getElementById("video" + this.currentIndex);
        videoEle && videoEle.pause();
      }
      this.currentIndex = index;
    },
    handleSmsReset() {
      this.isSmsSend = false;
      this.sendBtnText = "获取验证码";
      if (this.timer) {
        clearInterval(this.timer);
        this.counter = 60;
        this.timer = null;
      }
    },
    handleCountDown() {
      this.timer = setInterval(() => {
        this.sendBtnText = `重新发送（${this.counter}）`;
        this.counter--;
        if (this.counter < 0) {
          this.handleSmsReset();
        }
      }, 1000);
    },
    onConfirm(values, indexs) {
      const [provinceValue, cityValue] = values;
      const [provinceIndex, cityIndex] = indexs;
      const province = this.areaList[provinceIndex];
      const city = province.children[cityIndex];
      const area =
        (city.children && city.children.length && city.children[0]) ||
        undefined;
      this.form.provinceCode = province.mdCode;
      this.form.cityCode = city.mdCode;
      this.form.areaCode = (area && area.mdCode) || undefined;
      this.form.city = `${provinceValue} ${cityValue}`;
      this.showPicker = false;
    },
    handleSubmitClick() {
      if (!this.form.city || !this.form.city.trim()) {
        return this.$toast({ message: "请选择城市" });
      }
      if (!this.form.customerName || !this.form.customerName.trim()) {
        return this.$toast({ message: "请填写姓名" });
      }
      if (!isName(this.form.customerName)) {
        return this.$toast({ message: "请填写正确的姓名" });
      }
      if (!this.form.mobile || !this.form.mobile.trim()) {
        return this.$toast({ message: "请填写手机号" });
      }
      if (!isPhone(this.form.mobile)) {
        return this.$toast({ message: "请填写正确的手机号" });
      }
      if (this.isSmsVisable && !this.form.smsCode.trim()) {
        return this.$toast({ message: "请填写验证码" });
      }
      if (this.isSmsVisable && !isCode(this.form.smsCode)) {
        return this.$toast({ message: "请填写正确的验证码" });
      }

      if (this.isSmsVisable) {
        const params = {
          provinceCode: this.form.provinceCode,
          cityCode: this.form.cityCode,
          areaCode: this.form.areaCode || undefined,
          customerName: this.form.customerName,
          customerMobile: this.form.mobile,
          smsCode: this.form.smsCode,
          sourceCode: "b55d830176144171bef68d196877d2aa",
        };
        this.isOverlayShow = true;
        addLeadsSms(params).then((res) => {
          if (res.code === 200) {
            if (res.busCode === "1") {
              this.queryExistLeadsRequest(this.form.mobile);
              this.$toast({ message: "提交成功，我们将尽快与您取得联系" });
            } else {
              this.$toast({ message: res.busMessage });
              this.isOverlayShow = false;
            }
          } else {
            this.$toast({ message: res.message });
            this.isOverlayShow = false;
          }
        });
      } else {
        const params = {
          provinceCode: this.form.provinceCode,
          cityCode: this.form.cityCode,
          areaCode: this.form.areaCode || undefined,
          customerName: this.form.customerName,
          customerMobile: this.form.mobile,
          sourceCode: "b55d830176144171bef68d196877d2aa",
        };
        this.isOverlayShow = true;
        addLeads(params).then((res) => {
          if (res.code === 200) {
            if (res.busCode === "1") {
              this.queryExistLeadsRequest(this.form.mobile);
              this.$toast({ message: "提交成功，我们将尽快与您取得联系" });
            } else {
              this.$toast({ message: res.busMessage });
              this.isOverlayShow = false;
            }
          } else {
            this.$toast({ message: res.message });
            this.isOverlayShow = false;
          }
        });
      }
    },
    handleSendSmsCode() {
      if (!this.form.mobile || !this.form.mobile.trim()) {
        return this.$toast({ message: "请填写手机号" });
      }
      if (!isPhone(this.form.mobile)) {
        return this.$toast({ message: "请填写正确的手机号" });
      }
      getSmsCode({ mobile: this.form.mobile }).then((res) => {
        if (res.code === 200) {
          if (res.busCode === "1") {
            this.isSmsSend = true;
            this.isSmsFieldVisable = true;
            this.handleCountDown();
          } else {
            this.$toast({ message: res.busMessage });
          }
        } else {
          this.$toast({ message: res.message });
        }
      });
    },
  },
  watch: {
    "form.mobile": {
      handler: function (mobile) {
        if (this.phone) {
          if (mobile !== this.phone) {
            this.isSmsVisable = true;
            this.isSmsFieldVisable = true;
          } else {
            this.isSmsVisable = false;
            this.isSmsFieldVisable = false;
            this.handleSmsReset();
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.shop {
  background: #f2f2f2;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    font-size: 0;
    flex: 1;
    overflow-y: auto;
    img {
      width: 100%;
    }
  }
  .footer {
    box-shadow: 0px -1px 12px 0px rgba(58, 59, 60, 0.2);
    padding: 28px 40px 56px;
    background: white;
    position: relative;
    // position: absolute;
    // left: 0;
    // right: 0;
    // bottom: 0;
    // z-index: 1000;
    .submit {
      font-size: 28px;
      font-weight: 400;
      color: #111111;
      line-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      .img {
        width: 48px;
        margin-right: 15px;
      }
    }
    .row {
      margin-bottom: 16px;
      .van-field {
        margin-left: 1px;
      }
    }
    .row_1 {
      display: flex;
      .col {
        flex: 1;
        display: flex;
        padding: 1px 0;
        .col-title {
          flex: 0 0 100px;
          font-size: 28px;
          font-weight: 500;
          color: #3a3b3c;
          display: flex;
          align-items: center;
        }
        .col-title_2 {
          justify-content: center;
        }
        .van-field {
          flex: 1;
          padding: 10px 16px;
          background: #f2f2f2;
          border-radius: 12px;
          border: 1px solid #d4d4d4 !important;
        }
      }
    }
    .row_2 {
      display: flex;
      .row-title {
        flex: 0 0 100px;
        font-size: 28px;
        font-weight: 500;
        color: #3a3b3c;
        display: flex;
        align-items: center;
      }
      .van-field {
        flex: 1;
        padding: 10px 16px;
        background: #f2f2f2;
        border-radius: 12px;
        border: 1px solid #d4d4d4;
      }
      .code-action {
        border: none;
        outline: none;
        color: #ff6a39;
        font-size: 24px;
        padding: 4px 8px;
        border-radius: 8px;
      }
      .code-action__disabled {
        color: #a0a5aa;
      }
    }

    .footer-submit {
      .submit-action {
        width: 100%;
        border: none;
        outline: none;
        height: 90px;
        background: #ff6a39;
        font-size: 32px;
        font-weight: 500;
        color: #ffffff;
        line-height: 44px;
        border-radius: 48px;
        line-height: 90px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 180px;
        }
      }
      .submit-action__disabled {
        color: #a0a5aa;
      }
    }
  }
  .shop-overlay {
    background-color: rgba(0, 0, 0, 0.35);
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  }
}
</style>
